export default __webpack_public_path__ + "static/media/060_corner2.av1.dbe69eb6.mp4";